import { Pause, Play } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface LightAnimationPauseToggleProps {
  isPaused: boolean;
  onToggle: (value: boolean) => void;
}

export function LightAnimationPauseToggle({
  isPaused,
  onToggle,
}: LightAnimationPauseToggleProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onToggle(!isPaused)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              isPaused ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label={
              isPaused ? 'Resume light animations' : 'Pause light animations'
            }
          >
            {isPaused ? (
              <Play className="h-4 w-4 text-foreground" />
            ) : (
              <Pause className="h-4 w-4 text-foreground" />
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="border-border bg-background text-foreground"
        >
          <p>
            {isPaused ? 'Resume Light Animations' : 'Pause Light Animations'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
